import React from "react";
import { API } from "../../Services/api-services";
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
  ResponsiveContainer,
} from "recharts";
import { useEffect, useState } from "react";
import CircularProgressIndicator from "../../Core/Loader/CircularLoaderIndicator";
import Illustration from "../../assets/images/illustration.png";

function BarGraph({ type, date }) {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [err, setErr] = useState(false);
  const [cnt, setCnt] = useState(0);
  const getCount = (arr) => {
    let sum = 0;
    for (let i = 0; i < arr.length; i++) {
      if (type == "classes") {
        sum = sum + arr[i].totalClass + arr[i].paidClass;
      } else {
        sum = sum + arr[i].successfullDemos + arr[i].unsuccessfullDemos;
      }
    }
    return sum;
  };
  useEffect(() => {
    setLoading(true);
    setErr(false);
    API.post("/classDemosTracker", { date })
      .then((res) => {
        if (type == "demos") {
          setData(
            res.data.demos.map((demoData) => {
              return {
                ...demoData,
                "Successful Demos": demoData.successfullDemos,
                "UnSuccessful Demos": demoData.unsuccessfullDemos,
              };
            })
          );
          setCnt(getCount(res.data.demos));
        } else {
          setData(
            res.data.classes.map((classData) => {
              return {
                ...classData,
                "Total Classes": classData.totalClass,
                "Paid Classes": classData.paidClass,
              };
            })
          );
          setCnt(getCount(res.data.classes));
        }
        setLoading(false);
      })
      .catch((e) => {
        setLoading(false);
        setErr(true);
      });
  }, [type, date]);

  return (
    <React.Fragment>
      {loading ? (
        <div style={{ display: "flex", justifyContent: "center" }}>
          <CircularProgressIndicator />
        </div>
      ) : err || cnt == 0 ? (
        <center>
          <img src={Illustration} />
        </center>
      ) : (
        <ResponsiveContainer width="100%" height={300}>
          <BarChart
            data={data}
            margin={{
              top: 5,
              right: 30,
              left: 20,
              bottom: 5,
            }}
          >
            <CartesianGrid strokeDasharray="3 3" />
            <XAxis dataKey="name" />
            <YAxis />
            <Tooltip />
            <Legend />
            <Bar
              dataKey={type == "classes" ? "Total Classes" : "Successful Demos"}
              fill={type == "classes" ? "#2761BA" : "#FF712D"}
            />
            <Bar
              dataKey={
                type == "classes" ? "Paid Classes" : "UnSuccessful Demos"
              }
              fill={type == "classes" ? "#79BCF7" : "#FFD52D"}
            />
          </BarChart>
        </ResponsiveContainer>
      )}
    </React.Fragment>
  );
}

export default BarGraph;
